import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
export class MapService{
    private http = inject(HttpClient);
    getPosition(): Observable<GeolocationCoordinates> {
        return new Observable((observer) => {
            if (typeof navigator !== 'undefined' && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (pos) => observer.next(pos.coords),
                    (err) => observer.error(err),
                    { enableHighAccuracy: true, maximumAge: 0, timeout: 5000 }
                );
            } else {
                observer.error('Geolocation is not available in this environment.');
            }
        });
    }
    checkIfGpsEnabled(): Promise<boolean> {
        return new Promise((resolve) => {
            if (typeof navigator !== 'undefined' && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    () => resolve(true), // GPS is enabled
                    (error) => {
                        if (
                            error.code === error.PERMISSION_DENIED ||
                            error.code === error.POSITION_UNAVAILABLE
                        ) {
                            resolve(false); // GPS is disabled or permission denied
                        } else {
                            resolve(true);
                        }
                    }
                );
            } else {
                resolve(false); // Geolocation is not available
            }
        });
    }
}